import Card from '~/components/atoms/card/card';
import styles from './fulltextResult.module.scss';

export interface FulltextResultWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
    hasIcons: boolean;
}

const FulltextResultWrapper = ({ children, hasIcons, ...HTMLAttributes }: FulltextResultWrapperProps) => (
    <Card primary isInsideFulltext>
        <article className={hasIcons ? styles.serpResultWithIcon : ''} {...HTMLAttributes}>
            {children}
        </article>{' '}
    </Card>
);

export const FulltextResultWrapperWithIcons = ({
    children,
    ...HTMLAttributes
}: Omit<FulltextResultWrapperProps, 'hasIcons'>) => (
    <Card primary isInsideFulltext>
        <article className={styles.serpResultWithIcon} {...HTMLAttributes}>
            {children}
        </article>{' '}
    </Card>
);

export default FulltextResultWrapper;
